import {
  getComponentCssUrl,
  getGlobalCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavPortalMenuItemStylesTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavPortalMenuItem--wc.css')}" rel="stylesheet" />
`
  return t
}

const getNavPortalMenuItemStyles = () => createNavPortalMenuItemStylesTemplate()
export { getNavPortalMenuItemStyles }
